/**
 * WhatsApp Configuration & Utility for Wonder Herbals.
 */

export const WHATSAPP_CONFIG = {
    phoneNumber: '916262623111', // Official Wonder Herbals Line
    defaultMessage: 'Hi Wonder Herbals, I would like to know more about your Ayurvedic products.',
    cartQuoteHeader: 'Hi, I want to get a quote for my cart:\n\n',
    googleQuoteMessage: (context?: string) => 
        `Hi Wonder Herbals, I found you on Google. I am interested in ${context || 'your products'}. Could you help me with pricing?`,
};

/**
 * Generates a WhatsApp URL for a given product configuration
 */
export function generateProductWhatsAppUrl(productName: string, price?: number) {
    const message = `Hi Wonder Herbals, I want to inquire about:
Product: ${productName}
${price ? `Price: ₹${(price / 100).toLocaleString('en-IN')}` : ''}

Could you please provide more details?`;

    return `https://wa.me/${WHATSAPP_CONFIG.phoneNumber}?text=${encodeURIComponent(message)}`;
}

/**
 * Generates a WhatsApp URL for the entire cart
 */
export function generateCartWhatsAppUrl(items: any[], totalPrice: number) {
    if (!items || items.length === 0) {
        return `https://wa.me/${WHATSAPP_CONFIG.phoneNumber}?text=${encodeURIComponent(WHATSAPP_CONFIG.defaultMessage)}`;
    }

    let message = WHATSAPP_CONFIG.cartQuoteHeader;
    
    items.forEach(item => {
        message += `- ${item.name} (Qty: ${item.quantity}) - ₹${(item.price * item.quantity / 100).toLocaleString('en-IN')}\n`;
    });

    message += `\nTotal Price: ₹${(totalPrice / 100).toLocaleString('en-IN')}`;

    return `https://wa.me/${WHATSAPP_CONFIG.phoneNumber}?text=${encodeURIComponent(message)}`;
}
